/* eslint-disable */
import createIcon from '../createIcon';

const IconTableSortOutlined = createIcon({
  name: 'icon-table-sort-outlined',
  content: '<path d="M543.76 581v222.615l165.02-165.312 45.294 45.214-242.28 242.71L269 683.89l45.212-45.297L479.76 803.828V581h64zM511.795 97l242.28 242.71-45.296 45.214L543.76 219.612v222.615h-64V219.4L314.212 384.635 269 339.338 511.795 97z" fill="currentColor"/>',
  width: 1024,
  height: 1024
});
export default IconTableSortOutlined;
